import { IState } from '../types';

export class PhraseSelectPopupSelectors {

  public static getShow(state: IState): boolean {
    return state.phraseSelectPopup.show;
  }

}